export default __webpack_public_path__ + "static/media/guia_orientacion_toma_de_datos.9a7877a2.pdf";